import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HTTP_CP_EnergyPerformanceCertificate } from '@api-new/propertyservice';
import { CarouselComponent } from '@client-ui/components/carousel/carousel.component';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { TicketContainerDynamicComponent } from '@shared/components/ticket-container-dynamic/ticket-container-dynamic.component';

@Component({
  selector: 'cp-widget-epc-improvements-carousel',
  imports: [CommonModule, CarouselComponent, TicketContainerDynamicComponent, IconComponent],
  templateUrl: './widget-epc-improvements-carousel.component.html',
  styleUrl: './widget-epc-improvements-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetEpcImprovementsCarouselComponent {
  @Input({ required: true }) epc: HTTP_CP_EnergyPerformanceCertificate;
}
